// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"7b1d88c7","121":"fe36c5fe","307":"2caae58a","350":"bcaf6dbc","453":"f2b5bb1f","627":"3bc91f7b","945":"ed1629c8"}[chunkId] + ".chunk.js";
};